import { create } from "zustand";

type State = {selectedClassId: string; filter: string;};

type Actions = {
  setSelectedClassId: (classId: string) => void;
  setFilter: (filter: string) => void;
  reset: () => void;
};

export const useStudentsStore = create<State & Actions>((set) => ({
  selectedClassId: '',
  filter: '',
  setSelectedClassId: (classId: string) => set(() => ({ selectedClassId: classId })),
  setFilter: (filter: string) => set(() => ({filter})),
  reset: () => set(() => ({selectedClassId: '', selectedOrganizationId: ''}))
}));